(function() { function _dc_graph(d3, crossfilter, dc) {
'use strict';
